import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import SideBar from "./SideBar";
import Logo from "../../Assets/img/the-paperboy-logo-5.png";
// import Logo from "../../Assets/img/MainLogo.png";
import john_doe from "../../Assets/img/authors/profileImage.png";
import { Button } from "react-bootstrap";
import NotificationDropdown from "./Notifications";
import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../global";
import DefaultAvatar from "./../../Assets/img/avatar-default.jpeg";
import GlobalSearch from "./GlobalSearch";

const Navbar2 = ({active_quote_change}) => {
    const menuRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showNotficationMenu, setNotificationMenu] = useState(false);
    // const [showNotifications, setShowNotifications] = useState(false);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubCategories] = useState([]);

    const pk_user_key = sessionStorage.getItem("pk_user_key");
    const link = window.location.href;
    const [profile, setProfile] = useState(DefaultAvatar);
    const [isSticky, setIsSticky] = useState(false);

    const [openSearch, setOpenSearch] = useState(false);
    const [activeQuote, setactiveQuote] = useState();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoadingCat, setIsLoadingCat] = useState(true);

    const getActiveQuote = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getActiveQuote",
            });
            const output = response.data;
            if (output) {
                setactiveQuote(output);
            } else {
                setactiveQuote();
            }
        } catch (error) {
            console.error("Error fetching quote:", error);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                // Adjust the threshold as needed
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        getAllNavCategory();
        fetchAllSubCategory();
    }, []);
    useEffect(() => {

        getActiveQuote();
    }, [active_quote_change]);

    useEffect(() => {
        const isLoggedInStatus = sessionStorage.getItem("isLoggedIn");
        setIsLoggedIn(isLoggedInStatus === "true");

        const profileMod = sessionStorage.getItem("profile_mod");
        // FIXED: Added profileMod check to prevent "length" error
        if (profileMod && profileMod !== "null") {
            setProfile(IMAGE_URL + profileMod);
        }
    }, []);

    // const getAllNavCategory = async () => {
    //     const response = await axios.post(BASE_URL + "API/apicall", {
    //         security_key: security_key,
    //         mode: "getAllNavCategory",
    //     });

    //     const output = response.data;

    //     if (output.length > 0) {
    //         setCategories(output);
    //     }
    // };
    const getAllNavCategory = async () => {
        setIsLoadingCat(true); // Start loading
        
        const fallbackCategories = [
            { pk_cat_key: "home", cat_name: "HOME" },
            { pk_cat_key: 2, cat_name: "BREAKING" },
            { pk_cat_key: 3, cat_name: "JUSTICE" },
            { pk_cat_key: 4, cat_name: "ELECTIONS" },
            { pk_cat_key: 5, cat_name: "HISTORY" },
            { pk_cat_key: 6, cat_name: "EDUCATION" },
            { pk_cat_key: 7, cat_name: "ENVIRONMENT" },
            { pk_cat_key: 8, cat_name: "ENERGY" },
            { pk_cat_key: 9, cat_name: "GOVERNMENT" },
            { pk_cat_key: 10, cat_name: "POLITICS" },
            { pk_cat_key: 11, cat_name: "NEW CALIFORNIA STATE" },
            { pk_cat_key: 12, cat_name: "MUSIC" },
            { pk_cat_key: 13, cat_name: "OPINION" },
            { pk_cat_key: 14, cat_name: "TRADITION" },
            { pk_cat_key: 15, cat_name: "HEALTH" },
            { pk_cat_key: 16, cat_name: "IMMIGRATION" },
            { pk_cat_key: 17, cat_name: "ECONOMY" },
            { pk_cat_key: 18, cat_name: "RELIGION" },
            { pk_cat_key: 19, cat_name: "SPORTS" },
            { pk_cat_key: 20, cat_name: "WORLD" },
            { pk_cat_key: 21, cat_name: "COMEDY" }
        ];
        
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllNavCategory",
            });

            const output = response.data;
            
            if (Array.isArray(output) && output.length > 0) {
                // Force HOME to the beginning, then add the rest of the API categories
                const menuWithHome = [{ pk_cat_key: "home", cat_name: "HOME" }, ...output];
                setCategories(menuWithHome);
            } else {
                setCategories(fallbackCategories);
            }
        } catch (error) {
            console.error("Error fetching categories, using fallback:", error);
            setCategories(fallbackCategories);
        } finally {
            setIsLoadingCat(false); // Stop loading when done
        }
    };
    const fetchAllSubCategory = async () => {

        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllSubCategory",
        });

        const output = response.data;

        if (output.length > 0) {
            setsubCategories(output);
        }
    };

    console.log('subcategories', subcategories)

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const handleClick = () => {
        sessionStorage.clear();
        sessionStorage.removeItem("pk_user_key");
        setIsLoggedIn(false);
    };


    useEffect(() => {
        // const isLoggedInStatus = sessionStorage.getItem("pk_user_key");
        const isLoggedInStatus = sessionStorage.getItem("isLoggedIn");
        setIsLoggedIn(isLoggedInStatus === "true");

        const profileMod = sessionStorage.getItem("profile_mod");

        if (profileMod != "null") {
            // alert(typeof profileMod);
            setProfile(IMAGE_URL + profileMod);
        }
    }, []);

    const handleNotificationmenu = () => {
        setNotificationMenu(true);
    };

    const [showNavBar, setShowNavbar] = useState(true);
    const location = useLocation();

    const openMenuBarRoutes = [
        "/profile",
        "/admin",
        "/dashboard",
        "/downline",
        "/genealogy",
        "/ewallet",
        "/payout",
        "/settings",
        "/editmember",
        "/addmember",
        "/editprofile",
    ];

    const isMenuBarOpen = openMenuBarRoutes.some((route) => location.pathname.includes(route));

    const userType = sessionStorage.getItem("user_type");

    useEffect(() => {
        console.log(isLoggedIn);
    }, []);

    // Function to handle clicks outside the menu
    const handleClickOutside = (event) => {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsMenuOpen(false);
        }
    };

    // Add event listener for clicks outside
    useEffect(() => {
        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    const [activeCategory, setActiveCategory] = useState(null);
    const [filteredSubcategories, setFilteredSubcategories] = useState([]);


    const handleCategoryHover = (catKey) => {
        setActiveCategory(catKey);
        const filtered = subcategories.filter((sub) => sub.fk_cat_key === catKey);
        setFilteredSubcategories(filtered);
    };

    const handleCategoryLeave = () => {
        setActiveCategory(null);
        setFilteredSubcategories([]);
    };



    return (
        <>
            <header className="main-header header-style-2 header-sticky ">
                <div className="container pt-15 pb-15 position-relative text-center header-top">
                    <div className="mobile_menu d-lg-none d-block"></div>

                    <div className="row align-items-center justify-md-content-between">
                        <div className="col-2 col-md-4 pe-0">
                            <div className="d-sm-none d-md-none d-lg-flex">
                                <div className="off-canvas-toggle-cover d-inline-block">
                                    <SideBar />
                                </div>
                                <div className="global-search">
                                    <GlobalSearch />
                                </div>
                            </div>
                            <div className="d-sm-flex d-md-flex gap-md-2 d-lg-none text-sm-start ">
                                <div className="d-flex gap-1">
                                    <button
                                        className="btn px-2 my-1 btn-transparent border-0 d-lg-none d-flex align-items-center justify-content-center"
                                        type="button"
                                        ref={menuRef}
                                        onClick={toggleMenu}
                                    >
                                        <i className="ti-view-grid "></i>
                                    </button>{" "}
                                    <div className="global-search">
                                        <GlobalSearch />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-7 col-md-4 ">
                            <div className="logo-text ">
                                <h1 className="logo text-uppercase d-md-inline d-none" onClick={() => setShowNavbar(true)}>
                                    <Link to="/">
                                        <img src={Logo} alt="" />
                                    </Link>
                                </h1>
                                <h1 className="logo logo-mobile text-uppercase d-inline d-md-none">
                                    <Link to="/" className="ms-1">
                                        <img src={Logo} alt="" />
                                    </Link>
                                </h1>
                            </div>
                        </div>

                        <div className="col-3 col-md-4 text-md-end">
                            <div className="d-sm-none d-lg-block font-small d-lg-block mr-10">
                                <ul className="list-inline font-small text-right">
                                    {isLoggedIn || pk_user_key ? (
                                        <li className="list-inline-item dropdown d-sm-none d-lg-flex justify-content-end align-items-center">
                                            <div className="notification ">
                                                <NotificationDropdown />
                                            </div>
                                            <div className="dropdown">
                                                <a
                                                    className="mobile-profile d-flex align-items-center justify-content-end btn btn-transparent border-0 dropdown-toggle"
                                                    role="button"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <span className="pe-2" style={{ fontSize: "14px" }}>
                                                        {sessionStorage.getItem("full_name")}
                                                    </span>

                                                    <img src={profile} height={30} width={30} className="rounded-5" alt="Profile" />
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-end text-start">
                                                    {(userType == 1 || userType == 2) && (
                                                        <>
                                                            <li>
                                                                <Link className="dropdown-item" style={{ fontSize: "14px" }} to="/admin/admin-dashboard">
                                                                    <i className="fa-solid fa-user-tie me-2"></i> Admin
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item " style={{ fontSize: "14px" }} to="/admin/admin-profile">
                                                                    <i className="fa-regular fa-user me-2"></i> Profile
                                                                </Link>
                                                            </li>
                                                        </>
                                                    )}
                                                    {userType == 3 && (
                                                        <>
                                                            <li>
                                                                <Link className="dropdown-item" style={{ fontSize: "14px" }} to="/dashboard">
                                                                    <svg
                                                                        width="14"
                                                                        height="18"
                                                                        viewBox="0 0 18 18"
                                                                        fill="#000"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        className="me-2"
                                                                    >
                                                                        <path d="M8.16226 2.9V6.13333C8.16227 6.40106 8.1094 6.66615 8.00669 6.91339C7.90399 7.16063 7.75347 7.38515 7.56377 7.57407C7.37407 7.76299 7.14894 7.91259 6.90128 8.01429C6.65362 8.11598 6.38832 8.16776 6.1206 8.16667H2.90393C2.63693 8.16829 2.37235 8.11598 2.12606 8.01288C1.87976 7.90978 1.65682 7.75801 1.4706 7.56667C1.2819 7.37889 1.13242 7.15547 1.03085 6.90941C0.929275 6.66334 0.877635 6.39954 0.87893 6.13333V2.90833C0.878926 2.3705 1.09201 1.85457 1.47153 1.47349C1.85105 1.0924 2.3661 0.877204 2.90393 0.875H6.12893C6.39565 0.875256 6.65967 0.928419 6.9057 1.03141C7.15174 1.1344 7.3749 1.28517 7.56226 1.475C7.75221 1.66054 7.90315 1.88218 8.00619 2.1269C8.10923 2.37162 8.16229 2.63447 8.16226 2.9ZM17.1206 2.90833V6.13333C17.1163 6.66983 16.9018 7.18325 16.5232 7.56341C16.1446 7.94356 15.6321 8.16014 15.0956 8.16667H11.8623C11.3233 8.16337 10.8065 7.95129 10.4206 7.575C10.232 7.38541 10.0827 7.16048 9.98117 6.9131C9.87964 6.66571 9.82791 6.40074 9.82893 6.13333V2.90833C9.82779 2.6414 9.88031 2.37697 9.98338 2.13074C10.0865 1.88451 10.238 1.66151 10.4289 1.475C10.6163 1.28517 10.8395 1.1344 11.0855 1.03141C11.3315 0.928419 11.5955 0.875256 11.8623 0.875H15.0873C15.6252 0.879356 16.1398 1.09498 16.5202 1.47536C16.9006 1.85575 17.1162 2.37041 17.1206 2.90833ZM17.1206 11.8667V15.0917C17.1163 15.6282 16.9018 16.1416 16.5232 16.5217C16.1446 16.9019 15.6321 17.1185 15.0956 17.125H11.8623C11.3198 17.1305 10.7966 16.9242 10.4039 16.55C10.2146 16.361 10.0648 16.1361 9.96322 15.8886C9.86164 15.6411 9.81032 15.3759 9.81226 15.1083V11.8833C9.81117 11.6164 9.86371 11.352 9.96678 11.1058C10.0699 10.8595 10.2213 10.6365 10.4123 10.45C10.5997 10.2602 10.8228 10.1095 11.0689 10.0065C11.3149 9.90348 11.5789 9.8503 11.8456 9.85H15.0706C15.6085 9.85436 16.1232 10.07 16.5036 10.4504C16.8839 10.8307 17.0996 11.3454 17.1039 11.8833L17.1206 11.8667ZM8.16226 11.875V15.1C8.15571 15.6379 7.93798 16.1517 7.55603 16.5305C7.17409 16.9093 6.65854 17.1229 6.1206 17.125H2.90393C2.63769 17.1261 2.37388 17.0745 2.12769 16.9731C1.88151 16.8717 1.65784 16.7226 1.46958 16.5343C1.28132 16.3461 1.1322 16.1224 1.03115 15.8762C0.930097 15.63 0.878538 15.3661 0.878929 15.1V11.8667C0.880055 11.5993 0.932744 11.3348 1.03595 11.0885C1.13915 10.8422 1.29134 10.6197 1.48153 10.4333C1.66708 10.2444 1.88871 10.0951 2.13343 9.99355C2.37815 9.89202 2.641 9.83917 2.90726 9.84167H6.13226C6.66876 9.84595 7.18181 10.0603 7.56131 10.4407C7.9408 10.821 8.15641 11.3357 8.16226 11.875Z" />
                                                                    </svg>{" "}
                                                                    Dashboard
                                                                </Link>
                                                            </li>
                                                            <li>
                                                                <Link className="dropdown-item " style={{ fontSize: "14px" }} to="/profile">
                                                                    <i className="fa-regular fa-user me-2"></i> Profile
                                                                </Link>
                                                            </li>
                                                        </>
                                                    )}

                                                    <li>
                                                        <Link className="dropdown-item" style={{ fontSize: "14px" }} to="" onClick={handleClick}>
                                                            <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    ) : (
                                        <li className="list-inline-item mr-15">
                                            <Link to="/login" className="d-none d-lg-block">
                                                <i className="ti-user font-x-small mr-5"></i>Login
                                                {/* <Link to="/register"> Register</Link> */}
                                            </Link>{" "}
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="d-sm-flex d-md-block d-lg-none d-flex align-items-center justify-content-center">
                                {!isLoggedIn ? (
                                    <li>
                                        {" "}
                                        <Link to="/login" className="d-lg-none text-capitalize">
                                            <i className="ti-user font-x-small mr-5"></i>Login
                                        </Link>{" "}
                                    </li>

                                ) : (
                                    <li className="list-inline-item dropdown d-lg-none ">
                                        <div className="dropdown">
                                            <a
                                                className="mobile-profile btn btn-transparent border-0 dropdown-toggle"
                                                role="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <i className="bi bi-person-circle" style={{ fontSize: "26px" }}></i>
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-end text-start">
                                                {(userType == 1 || userType == 2) && (
                                                    <li>
                                                        <Link className="dropdown-item" style={{ fontSize: "14px" }} to="/admin/admin-dashboard">
                                                            <i className="fa-solid fa-user-tie me-2"></i> Admin
                                                        </Link>
                                                    </li>
                                                )}
                                                {userType == 3 && (
                                                    <li>
                                                        <Link className="dropdown-item" style={{ fontSize: "14px" }} to="/dashboard">
                                                            <svg
                                                                width="14"
                                                                height="18"
                                                                viewBox="0 0 18 18"
                                                                fill="#000"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="me-2"
                                                            >
                                                                <path d="M8.16226 2.9V6.13333C8.16227 6.40106 8.1094 6.66615 8.00669 6.91339C7.90399 7.16063 7.75347 7.38515 7.56377 7.57407C7.37407 7.76299 7.14894 7.91259 6.90128 8.01429C6.65362 8.11598 6.38832 8.16776 6.1206 8.16667H2.90393C2.63693 8.16829 2.37235 8.11598 2.12606 8.01288C1.87976 7.90978 1.65682 7.75801 1.4706 7.56667C1.2819 7.37889 1.13242 7.15547 1.03085 6.90941C0.929275 6.66334 0.877635 6.39954 0.87893 6.13333V2.90833C0.878926 2.3705 1.09201 1.85457 1.47153 1.47349C1.85105 1.0924 2.3661 0.877204 2.90393 0.875H6.12893C6.39565 0.875256 6.65967 0.928419 6.9057 1.03141C7.15174 1.1344 7.3749 1.28517 7.56226 1.475C7.75221 1.66054 7.90315 1.88218 8.00619 2.1269C8.10923 2.37162 8.16229 2.63447 8.16226 2.9ZM17.1206 2.90833V6.13333C17.1163 6.66983 16.9018 7.18325 16.5232 7.56341C16.1446 7.94356 15.6321 8.16014 15.0956 8.16667H11.8623C11.3233 8.16337 10.8065 7.95129 10.4206 7.575C10.232 7.38541 10.0827 7.16048 9.98117 6.9131C9.87964 6.66571 9.82791 6.40074 9.82893 6.13333V2.90833C9.82779 2.6414 9.88031 2.37697 9.98338 2.13074C10.0865 1.88451 10.238 1.66151 10.4289 1.475C10.6163 1.28517 10.8395 1.1344 11.0855 1.03141C11.3315 0.928419 11.5955 0.875256 11.8623 0.875H15.0873C15.6252 0.879356 16.1398 1.09498 16.5202 1.47536C16.9006 1.85575 17.1162 2.37041 17.1206 2.90833ZM17.1206 11.8667V15.0917C17.1163 15.6282 16.9018 16.1416 16.5232 16.5217C16.1446 16.9019 15.6321 17.1185 15.0956 17.125H11.8623C11.3198 17.1305 10.7966 16.9242 10.4039 16.55C10.2146 16.361 10.0648 16.1361 9.96322 15.8886C9.86164 15.6411 9.81032 15.3759 9.81226 15.1083V11.8833C9.81117 11.6164 9.86371 11.352 9.96678 11.1058C10.0699 10.8595 10.2213 10.6365 10.4123 10.45C10.5997 10.2602 10.8228 10.1095 11.0689 10.0065C11.3149 9.90348 11.5789 9.8503 11.8456 9.85H15.0706C15.6085 9.85436 16.1232 10.07 16.5036 10.4504C16.8839 10.8307 17.0996 11.3454 17.1039 11.8833L17.1206 11.8667ZM8.16226 11.875V15.1C8.15571 15.6379 7.93798 16.1517 7.55603 16.5305C7.17409 16.9093 6.65854 17.1229 6.1206 17.125H2.90393C2.63769 17.1261 2.37388 17.0745 2.12769 16.9731C1.88151 16.8717 1.65784 16.7226 1.46958 16.5343C1.28132 16.3461 1.1322 16.1224 1.03115 15.8762C0.930097 15.63 0.878538 15.3661 0.878929 15.1V11.8667C0.880055 11.5993 0.932744 11.3348 1.03595 11.0885C1.13915 10.8422 1.29134 10.6197 1.48153 10.4333C1.66708 10.2444 1.88871 10.0951 2.13343 9.99355C2.37815 9.89202 2.641 9.83917 2.90726 9.84167H6.13226C6.66876 9.84595 7.18181 10.0603 7.56131 10.4407C7.9408 10.821 8.15641 11.3357 8.16226 11.875Z" />
                                                            </svg>{" "}
                                                            Dashboard
                                                        </Link>
                                                    </li>
                                                )}

                                                {(userType == 1 || userType == 2) && (
                                                    <li>
                                                        <Link className="dropdown-item " style={{ fontSize: "14px" }} to="/admin/admin-profile">
                                                            <i className="fa-regular fa-user me-2"></i> Profile
                                                        </Link>
                                                    </li>
                                                )}
                                                {userType == 3 && (
                                                    <li>
                                                        <Link className="dropdown-item " style={{ fontSize: "14px" }} to="/profile">
                                                            <i className="fa-regular fa-user me-2"></i> Profile
                                                        </Link>
                                                    </li>
                                                )}
                                                <li>
                                                    <Link className="dropdown-item" style={{ fontSize: "14px" }} to="" onClick={handleClick}>
                                                        <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                )}
                            </div>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "20px 0" }}>
                        <div>
                            {!isLoggedIn && (


                                <h1 style={{ fontSize: "35px", fontWeight: "600", marginRight: "10px" }}>
                                    Become a PaperBoy Distributor - Read, Watch, Share & Earn
                                </h1>
                            )}

                            {activeQuote && activeQuote.quote && (
                                <figure className="quote-card" style={{ margin: "0 auto", textAlign: "center", maxWidth: "700px" }}>
                                    <p className="quote-text">
                                        <span className="quote-mark">“</span>
                                        {activeQuote.quote}
                                        <span className="quote-mark">”</span>
                                    </p>
                                    {activeQuote.author_name && (
                                        <figcaption className="quote-author">
                                            {activeQuote.author_name}
                                        </figcaption>
                                    )}
                                </figure>
                            )}
                        </div>
                        {!isLoggedIn && (
                            <Link to="/signup">
                                <button
                                    style={{
                                        border: "2px solid black",
                                        background: "white",
                                        padding: "6px 12px",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        textTransform: "uppercase",
                                        marginLeft: "15px",
                                    }}
                                >
                                    Sign Me Up!
                                </button>
                            </Link>
                        )}
                    </div>


                </div>
                {!isMenuBarOpen && (
                    <div className={`main-navigation text-uppercase font-heading ${isSticky ? "sticky-bar" : ""}`}>
                        <div className="container">
                            <div className="horizontal-divider-black"></div>
                        </div>

                        <div className="main-nav d-lg-block">
                            <nav className="container text-start px-0">
                                <ul className="main-menu d-none d-lg-inline">
                                    {/* <li className="menu-item-has-children   ">
                                        <Link to="/home" className="pe-0">
                                            Home
                                        </Link>
                                    </li> */}
                                    {(categories || [])?.map((category) => (
                                        <li
                                            key={category.pk_cat_key}
                                            onMouseEnter={() => handleCategoryHover(category.pk_cat_key)}
                                            onMouseLeave={handleCategoryLeave}
                                            className="category-item"
                                        >
                                            <Link to={category.pk_cat_key === "home" ? "/home" : `/category/${category.pk_cat_key}`}>
                                                {category.cat_name}
                                            </Link>

                                            {activeCategory === category.pk_cat_key &&
                                                filteredSubcategories.length > 0 && (
                                                    <ul className="subcategory-inline">
                                                        {filteredSubcategories.map((sub) => (
                                                            <li key={sub.pk_sub_cat_key}>
                                                                <Link to={`/subcategory/${sub.pk_sub_cat_key}`}
                                                                    state={{
                                                                        categoryKey: category.pk_cat_key,
                                                                        subcategoryKey: sub.pk_sub_cat_key,
                                                                    }}>
                                                                    {sub.subcat_name}
                                                                </Link>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                        </li>
                                    ))}
                                </ul>

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    {/* <button
                    className="btn p-1 my-1 btn-transparent border d-lg-none"
                    type="button"
                    ref={menuRef}
                    onClick={toggleMenu}
                  >
                    ☰
                  </button> */}

                                    {/* {!isLoggedIn ? (
                    <li>
                      {" "}
                      <Link to="/login" className="d-lg-none text-capitalize">
                        <i className="ti-user font-x-small mr-5"></i>Login
                       
                      </Link>{" "}
                    </li>
                  ) : (
                    <li className="list-inline-item dropdown d-lg-none ">
                      <div className="dropdown">
                        <a
                          className="mobile-profile btn btn-transparent border-0 dropdown-toggle"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i
                            className="bi bi-person-circle"
                            style={{ fontSize: "26px" }}
                          ></i>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end text-start">
                          <li className="px-2 text-capitalize">
                            <Link
                              className="dropdown-item py-1 ps-2"
                              style={{ fontSize: "14px" }}
                              to="/profile"
                            >
                              <i className="fa-regular fa-user me-2"></i>{" "}
                              Profile
                            </Link>
                          </li>
                          <li className="px-2 text-capitalize">
                            <Link
                              className="dropdown-item py-1 ps-2"
                              style={{ fontSize: "14px" }}
                              to="/admin/admin-dashboard"
                            >
                              <i className="fa-solid fa-user-tie me-2"></i>{" "}
                              Admin
                            </Link>
                          </li>
                          <li className="px-2 text-capitalize">
                            <Link
                              className="dropdown-item py-1 ps-2"
                              style={{ fontSize: "14px" }}
                              to=""
                              onClick={handleClick}
                            >
                              <i className="fa-solid fa-right-from-bracket me-2"></i>{" "}
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  )} */}

                                    {/* Off-Canvas Menu */}
                                    <div
                                        className={` offcanvas offcanvas-top ${isMenuOpen ? "show" : ""}`}
                                        tabIndex="-1"
                                        id="offCanvasMenu"
                                        style={{ width: "100%" }}
                                    >
                                        <div className="offcanvas-header pb-0">
                                            <h5 className="offcanvas-title">Menu</h5>
                                            <button type="button" className="btn-close" onClick={toggleMenu}></button>
                                        </div>
                                        {/* <div className="offcanvas-body pb-0 pt-2">
                                            <ul className="list-unstyled">
                                                <li className="border-bottom">
                                                    <Link to="/home">Home</Link>
                                                </li>
                                                {categories.map((category) => (
                                                    <li key={category.pk_cat_key} className="border-bottom ">
                                                        <Link to={`/category/${category.pk_cat_key}`}>{category.cat_name}</Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div> */}
                                    </div>
                                </div>
                            </nav>
                        </div>

                        <div className="container d-sm-none d-md-none d-lg-block">
                            <div className="horizontal-divider-black mb-1px"></div>
                        </div>
                        <div className="container d-sm-none d-md-none d-lg-block">
                            <div className="horizontal-divider-black"></div>
                        </div>
                    </div>
                )}
                <div className="container d-md-block d-lg-none">
                    <div className="horizontal-divider-black mb-1px"></div>
                </div>
                <div className="container d-md-block d-lg-none">
                    <div className="horizontal-divider-black"></div>
                </div>
            </header>
            <style jsx>
                {`
                    /* MobileMenu.css */
                    .mobile-profile > .dropdown-menu > .dropdown-item {
                        padding: 0px 10px !important;
                    }

                    /* Hide the off-canvas menu by default */
                    .offcanvas {
                        transform: translateX(100%);
                        transition: transform 0.5s ease;
                    }
                    .offcanvas.offcanvas-top {
                        top: 0px;
                        height: fit-content;
                    }
                    /* Show the off-canvas menu */
                    .offcanvas.show {
                        transform: translateX(0);
                    }

                    /* Off-canvas header styles */
                    .offcanvas-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .offcanvas-body ul {
                        padding-left: 0;
                    }

                    .offcanvas-body ul li {
                        margin: 10px 0;
                    }

                    .offcanvas-body ul li a {
                        text-decoration: none;
                        color: #333;
                    }

                    .offcanvas-body ul li a:hover {
                        color: #007bff; /* Hover color */
                    }

                    .sticky {
                        position: fixed;
                        top: 0;
                        width: 100%;
                        z-index: 1000;
                        background-color: #fff;
                    }
                        .category-list {
  display: flex;
  justify-content: center;
  gap: 25px;
  padding: 10px 0;
  margin: 0;
  list-style: none;
  border-bottom: 2px solid #000;
}

.category-item {
  position: relative;
  white-space: nowrap;
}

.category-item a {
  text-decoration: none;
  color: #000;
  font-weight: 600;
}

.category-item:hover a {
  color: #d11a2a;
}

/* Subcategories inline under the hovered category */
.subcategory-inline {
  position: absolute;
  top: 25px;
  left: 0;
  display: flex;
  flex-wrap: nowrap;
  list-style: none;
  z-index: 1000;
}

.subcategory-inline li {
  margin-right: 20px;
}

.subcategory-inline li:last-child {
  margin-right: 0;
}

.subcategory-inline li a {
  text-decoration: none;
  color: #000;
  font-weight: 500;
}

.subcategory-inline li a:hover {
  text-decoration: underline;
  color: #d11a2a;
}


                `}
            </style>
        </>
    );
};

export default Navbar2;
